<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'tableCom',
})
</script>
<template>
	<div class="fileBox">
		<div v-if="fileList.length > 0 && (title || defaultTitle) != ''" class="fileTitle">{{ title || defaultTitle }}</div>
		<div class="fileGrid">
			<div v-for="item in fileList" :key="item.url" class="fileItem" @click="handleFileClick(item)">
				<div class="fileIcon">
					<img :src="getFileTypeSvg(item.url)" :alt="getFileType(item.url)" class="iconImage" />
				</div>
				<div class="fileInfo">
					<div class="fileName">{{ item.name }}</div>
					<div class="fileSize">{{ formatFileSize(item.size || 0) }}</div>
				</div>
			</div>
		</div>

		<!-- 图片预览 -->
		<el-image
			v-if="previewImage"
			:preview-teleported="true"
			style="width: 100px; height: 100px"
			:src="constant.apiUrl + previewImage"
			:initial-index="4"
			:preview-src-list="fileList.filter((e: any) => isImage(e.url)).map((e: any) => constant.apiUrl + e.url)"
		/>

		<!-- 文件预览对话框 -->
		<el-dialog
			v-if="fileShow"
			v-model="fileShow"
			:title="t('components.common.onlinePreview.preview')"
			:close-on-click-modal="false"
			width="834px"
			top="6vh"
		>
			<div style="height: 76vh; width: 800px">
				<vue-office-docx v-if="fileType === 'docx'" :src="fileURL" style="height: 100%" />
				<vue-office-pdf v-if="fileType === 'pdf'" :src="fileURL" style="height: 100%" />
				<vue-office-excel v-if="fileType === 'xlsx' || fileType === 'xls'" :src="fileURL" style="height: 100%" />
				<vue-office-pptx v-if="fileType === 'pptx' || fileType === 'ppt'" :src="fileURL" style="height: 100%" />
			</div>
		</el-dialog>
	</div>
</template>

<script setup lang="ts" name="tableCom">
import { defineProps, onMounted, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import constant from '@/utils/constant'
import VueOfficePdf from '@vue-office/pdf'
import VueOfficeExcel from '@vue-office/excel'
import '@vue-office/excel/lib/index.css'
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'
import VueOfficePptx from '@vue-office/pptx'
import { getFileTypeSvg, getFileType, formatFileSize } from '@/utils/fileTypeIcon'

const { t } = useI18n()

onMounted(() => {})
const fileType = ref('')
const fileURL = ref('')
const fileShow = ref(false)
const previewImage = ref('')

const props = defineProps({
	fileList: {
		type: Array as () => Record<string, any>,
		default() {
			return []
		}
	},
	title: {
		type: String,
		default: ''
	}
})

// 计算属性：默认标题
const defaultTitle = computed(() => {
	if (!props.title) {
		return t('componentsModule.common.attachmentList.title')
	}
	return ''
})

const emit = defineEmits([])

const isImage = (url: any) => {
	return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url)
}

const handleFileClick = (item: any) => {
	if (isImage(item.url)) {
		// 图片直接预览
		previewImage.value = item.url
	} else {
		const href = `${constant.previewUrl}?url=${btoa(item.url)}`
		window.open(href)
	}
}

const handlePreview = (url: string) => {
	// let type = url.split('.')[url.split('.').length - 1]
	// // vue-office-docx不支持doc格式，只支持docx格式
	// if (['docx', 'pdf', 'xlsx', 'pptx', 'xls', 'ppt'].includes(type)) {
	// 	fileType.value = type
	// 	fileURL.value = constant.apiUrl + url
	// 	fileShow.value = true
	// } else if (type === 'doc') {
	// 	// doc格式不支持预览，直接下载
	// 	window.open(constant.apiUrl + url)
	// } else {
	// 	window.open(constant.apiUrl + url)
	// }
}

defineExpose({})
</script>

<style scoped lang="scss">
.fileBox {
	.fileTitle {
		font-size: 16px;
		font-weight: 600;
		color: #333;
		margin-bottom: 16px;
	}

	.fileGrid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
		gap: 16px;
	}

	.fileItem {
		display: flex;
		align-items: center;
		padding: 6px 0;
		border: 1px solid #e4e7ed;
		border-radius: 8px;
		background: #ece9e9;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			border-color: #409eff;
			box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
		}

		.fileIcon {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-right: 12px;
			min-width: 60px;

			.iconImage {
				width: 40px;
				height: 40px;
				margin-bottom: 4px;
			}

			.fileType {
				font-size: 12px;
				color: #666;
				font-weight: 500;
			}
		}

		.fileInfo {
			flex: 1;
			min-width: 0;

			.fileName {
				font-size: 14px;
				color: #333;
				font-weight: 500;
				margin-bottom: 4px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.fileSize {
				font-size: 12px;
				color: #999;
			}
		}
	}
}
</style>
